<script>
    export let name = ''
    const icon = require(`/../resources/shapes/SVG/${name}.svg`)
</script>

{#if icon}
    {@html icon}
{/if}
